/* eslint-disable */
import { axiosRPC } from './../../plugins/RPC'
const env = require('./../../../.environment')

let translate = {
  catalog: {},
  formats: {},
  plural: '(n !== 1)',
  pluralidx: function(n) {
    let v = eval(translate.plural)
    if (typeof (v) === 'boolean') {
      return v ? 1 : 0
    } else {
      return v
    }
  }
}

let event = document.createEvent('Event')
event.initEvent('translateReceived', true, true)

export function receiveLanguage (lang) {
  return new Promise((resolve) => {
    axiosRPC.call(env.RPC_ENDPOINT, 'core.webapp.get_trans_and_local_data', {lang: lang}).then(res => {
      translate.catalog = res.data.result.data.catalog
      translate.formats = res.data.result.data.formats
      translate.plural = res.data.result.data.plural
      document.dispatchEvent(event)
      resolve(res)
    }).catch(err => {
      throw err
    })
  })
}

export function ready (callback) {
  document.addEventListener('translateReceived', function () {
    callback()
  }, false)
}

export function gettext (text) {
  let value = translate.catalog[text]
  if (typeof (value) === 'undefined') {
    return text
  } else {
    return (typeof (value) === 'string') ? value : value[0]
  }
}

export function ngettext (singular, plural, count) {
  let value = translate.catalog[singular]
  if (typeof (value) === 'undefined') {
    return (count === 1) ? singular : plural
  } else {
    return value[translate.pluralidx(count)]
  }
}

export function gettext_noop (msgid) {
  return msgid
}

export function pgettext (context, msgid) {
  let value = gettext(context + '\x04' + msgid)
  if (value.indexOf('\x04') !== -1) {
    value = msgid
  }
  return value
}

export function npgettext (context, singular, plural, count) {
  let value = ngettext(context + '\x04' + singular, context + '\x04' + plural, count)
  if (value.indexOf('\x04') !== -1) {
    value = ngettext(singular, plural, count)
  }
  return value
}

export function interpolate (fmt, obj, named) {
  if (named) {
    return fmt.replace(/%\(\w+\)s/g, function(){return String(obj.shift())})
  } else {
    return fmt.replace(/%s/g, function(){return String(obj.shift())})
  }
}

export function get_format (format_type) {
  let value = translate.formats[format_type]
  if (typeof (value) === 'undefined') {
    return format_type
  } else {
    return value
  }
}



// WEBPACK FOOTER //
// ./src/services/TranslateHandler/index.js